import React, { useState, useEffect } from 'react';
import Field from './Field';
import { useStyles } from '../../Login/UserLoginForm/UserLoginForm.styles';
const isUsernameValid = (username) => {
    return username.length ? true : false;
    //TODO: improve
};
export const UsernameField = (props) => {
    const [username, setUsername] = useState('');
    const [validUsername, setValidUsername] = useState(false);
    const onChange = props.onChange;
    const classes = useStyles();
    useEffect(() => {
        if (props.value !== undefined) {
            setUsername(props.value);
        }
    }, [props.value]);
    useEffect(() => {
        const valid = isUsernameValid(username);
        onChange(valid ? username : undefined);
        setValidUsername(valid);
    }, [username, onChange]);
    const handleInputChange = (event) => {
        setUsername(event.target.value);
    };
    return (React.createElement(Field, { required: props.required, name: "username", placeholder: props.placeholder, autoComplete: "username", error: username.trim().length > 0 && !validUsername, label: props.label, sx: classes.input, value: username, onChange: handleInputChange }));
};
export default UsernameField;
